export const ErrorMessage = {
  GENERIC: 'Oops! Something went wrong!\nPlease try again.',
  GENERIC_CRASH: 'Oops! Something went wrong!\nOur team has been notified of this.',
  INVALID_ACCOUNT_NUMBER: 'Invalid account number.',
  INVALID_LOGIN_CREDENTIALS: 'Invalid username/password.',
  INVALID_MFA_ONE_TIME_PASSWORD: 'Invalid or expired security code.',
  MISSING_MFA_ONE_TIME_PASSWORD: 'A security code was not found. Please request a new one.',
  EMAIL_MFA_TOO_MANY_REQUESTS:
    'A security code was recently sent to your email. Please wait a little while before requesting another one.',
  INVALID_CUSTOMER_TOKEN: 'Invalid credentials',
  INVALID_API_TOKEN: 'Please provide a valid API token.',
  CASH_PAYMENT_NOT_SUPPORTED: 'Sorry! Cash payments are not supported online.',
  CUSTOMER_ALREADY_EXISTS: 'This email is already in use. Please use a different one.',
  CUSTOMER_NOT_VERIFIED:
    'Sorry, your account has not been verified yet. Please check your email for a verification link.',
  CUSTOMER_DISABLED: 'Your account has been disabled. Please contact the administrator.',
  CUSTOMER_DELETED: 'Your account has been deleted. Please contact the administrator.',
  PASSWORD_ALREADY_USED: 'Sorry, you have already used this password. Please choose a new one.',
  ORDER_ALREADY_SENT: 'This order has already been sent.',
  ORDER_ABANDONED: 'This order was abandoned',
  ORDER_BEING_PROCESSED: 'This order is being processed.',
  ORDER_TOTAL_BELOW_MIN_XXX: 'Please ensure your order size is above the minimum of ',
  ORDER_TOTAL_ABOVE_MAX: 'For large orders, please see a staff member.',
  ORDER_THROTTLE_MAX_EXCEEDED:
    'Sorry! The restaurant is experiencing more demand than it can handle. Please try with a different order time.',
  ORDER_REQUEST_OUTDATED: 'Your request is outdated.',
  ORDER_INCOMPATIBLE_API_VERSION: 'The order in your request has an incompatible API version.',
  KITCHEN_IS_CLOSING: 'Please order from the cashier as the kitchen is closing soon.',
  KITCHEN_IS_CLOSED: 'Sorry, the kitchen is closed.',
  LOYALTY_NO_MATCHING_USER: "Sorry! We couldn't find this rewards account. Please try again.",
  LOYALTY_MINIMUM_ORDER_AMOUNT_NOT_MET: 'Sorry, the minimum order amount has not been met.',
  LOYALTY_USER_DISABLED: 'Sorry, this rewards account is disabled.',
  GIFT_CARD_NOT_FOUND: "Sorry! We couldn't find this gift card. Please try again.",
  GIFT_CARD_INACTIVE: 'Sorry, this gift card is not active.',
  STUDENT_CARD_NOT_FOUND: "Sorry! We couldn't find this student card. Please try again.",
  STUDENT_CARD_INSUFFICIENT_FUNDS: 'Sorry, this student card is out of funds.',
  STUDENT_CARD_INACTIVE: 'Sorry, this student card is not active.',
  STORED_VALUE_PIN_WRONG: 'Sorry! Looks like either the card number or the PIN code is incorrect.',
  STORED_VALUE_PIN_REQUIRED: 'Sorry! Looks like a PIN code is required for this gift card.',
  STORED_VALUE_RESTRICTED: 'Sorry, this card cannot be used at this time.',
  STORED_VALUE_CANNOT_BE_USED: 'Sorry, this card cannot be used if you wish to pay at the cashier.',
  POS_ORDERING_TURNED_OFF:
    'We apologize. Kiosk ordering is currently turned off. Please order from the counter instead.',
  ERROR_PROCESSING_PAYMENT: 'We are having trouble processing the payment. Please try again.',
  ITEM_86D:
    'Apologies, there is a problem on this order. Please update your order to remove any unavailable items to try this order again.',
  COUPON_ALREADY_USED: 'Sorry, this coupon has already been applied to a different order.',
  COUPON_NOT_FOUND: 'Coupon code not found.',
  COUPON_ITEM_IS_NOT_ORDERED: 'Sorry, this coupon only applies to certain items.',
  COUPON_CANNOT_BE_USED: 'Sorry, this coupon cannot be used with this order.',
  COUPON_MIN_SPEND_UNMET: 'In order to use this coupon, you must spend at least ',
  COUPON_ONLY_VALID_ON: 'Sorry, this coupon can only be used on',
  COUPON_ONLY_VALID_BETWEEN: 'Sorry, this coupon can only be used between',
  COUPON_NO_LONGER_VALID: 'Sorry, this coupon is no longer valid.',
  EXTERNAL_NETWORK: "Sorry! We're having trouble reaching the kitchen. Please try again.",
  EXTERNAL_BAD_USER_INPUT: 'Sorry! The information you submitted appears to be incorrect.',
  EXTERNAL_FAILED_IMAGE_DOWNLOAD: 'There was an error downloading the image from ',
  ASAP_ORDERS_NOT_AVAILABLE: 'ASAP ordering is not available for your chosen dining option.',
  FUTURE_ORDERS_NOT_AVAILABLE: 'Order ahead is not available for your chosen dining option.',
  NO_KIOSK_FOR_SERIAL:
    'Failed to find a kiosk with this serial number.\nPlease contact your account representative for help.',
  NO_KIOSK_DEVICE_STATUS:
    'Failed to find the device status of this kiosk.\nPlease contact your account representative for help.',
  INVALID_KIOSK_BUILD:
    'The requested function is unavailable for this kiosk.\nPlease contact your account representative for help.',
  INVALID_KIOSK_OS:
    'The requested function is unavailable for this kiosk.\nPlease contact your account representative for help.',
  LOYALTY_CARD_INACTIVE: 'Please activate this card first before using it.',
  LOYALTY_NOT_ACTIVATED: 'Sorry! The loyalty program is not activated on this kiosk yet.',
  LOYALTY_ENROLLMENT_NOT_ACTIVATED: 'Sorry! The loyalty program is does not support enrollment.',
  READ_ERROR: 'Failed to read the card. Please try again.',
  CHARGE_ERROR: 'Failed to charge the specified card. Please try again.',
  REFUND_ERROR: 'Failed to refund the specified transaction. Please try again.',
  REFUND_TRANSACTION_TOO_OLD:
    'Failed to refund the specified transaction. The transaction is too old to be refunded.',
  TOKENIZATION_ERROR: 'Failed to store the specified card. Please try again.',
  INVALID_AMOUNT: 'Invalid amount',
  INVALID_CARD_ON_FILE: 'Sorry, this card cannot be used at this time.',
  IFRAME_ERROR: 'Sorry, payments are currently unavailable at this time. Please try again later.',
  TIP_UNSUPPORTED: 'Sorry, tips cannot be added to this order.',
  ONE_REWARD_PER_VISIT: 'Sorry, you can only use rewards once per visit.',
  LOYALTY_UNABLE_TO_APPLY:
    'Sorry, this discount could not be applied. Please try again or please see a staff member for help.',
  FLASH_NOT_ENABLED: 'Sorry, the location you are requesting is not available for online ordering.',
  PLEASE_ENTER_EMAIL: 'Please enter a valid email address',
  PLEASE_ENTER_CREDIT_CARD: "Please make sure you've entered your credit card",
  PLEASE_CHECK_ZIP_CODE:
    'The ZIP code provided is incorrect. Please check the card’s ZIP code or use a different card.',
  PLEASE_CHECK_CVV_CODE:
    'The security code provided is incorrect. Please check the card’s security code or use a different card.',
  PLEASE_CHECK_CARD_NUMBER:
    'The card number provided is incorrect. Please check the card’s number or use a different card.',
  PLEASE_CALL_FOR_AUTHORIZATION: 'Please call for authorization.',
  PLEASE_PAY_AT_CASHIER: 'Please pay at the cashier.',
  CARD_DECLINED: 'Your card was declined. Please try another card.',
  CARD_EXPIRED: 'Your card is expired. Please use a different card.',
  TRANSACTION_NOT_ALLOWED:
    'Your card does not support this type of purchase. Please use a different card.',
  PLEASE_USE_TEST_CARD: 'This location is still in test mode. Please use a test card to pay.',
  NO_RESOURCE_ACCESS_RIGHTS: "You don't have rights to access this resource.",
  CUSTOMER_TOO_MANY_FAVORITES: 'Sorry, max 5 favorites per store.',
  CUSTOMER_INVALID_FAVORITE: "Sorry, that favorite doesn't exist.",
  ORDER_LOCKED: 'This order is being worked on right now. Please try again in a moment.',
  LOCATION_INVALID_SEARCH_QUERY_PARAMS: 'Address or latitude and longitude required.',
  LOCATION_INVALID_ADDRESS_QUERY_PARAM:
    'Please add more details to your address. Include Street, City and State for best results.',
  LOCATION_DELIVERY_ADDRESS_OUT_OF_RANGE:
    'Sorry, but your delivery address is out of range for this store. Please choose another address or select a different store.',
  LOCATION_DELIVERY_ADDRESS_INVALID_FIELD_STREET: 'Sorry, but your street address is invalid.',
  AUTH_GENERIC_ERROR: 'Sorry, we were unable to sign you in at this time.',
  CANNOT_MODIFY_TIP_AFTER_PAYMENT:
    'Sorry, you cannot modify your tip once you have paid for the order.',
  CANNOT_MODIFY_LOYALTY_AFTER_PAYMENT:
    'Sorry, you cannot modify your loyalty information once you have paid for the order.',
  CANNOT_MODIFY_COUPON_AFTER_PAYMENT:
    'Sorry, you cannot add or remove coupons once you have paid for the order.',
  REWARD_NOT_APPLICABLE:
    'Provided loyalty discount is greater than order subtotal and cannot be applied.',
  MDM_DEVICE_NOT_FOUND: 'This device is missing from MDM',
  NO_QUALIFYING_ITEMS_FOR_REWARD: 'No qualifying item found for the reward.',
  API_RATE_LIMIT: 'Too many requests, please try again later.',
  WEBHOOK_ERROR: 'Did not receive successful response when sending webhook.',
  NOTIFIER_SEND_ERROR: 'Could not send notification.',
  MISSING_PAYMENT_TERMINAL_SERIAL_NUMBER: 'Missing payment terminal serial number.',
  KIOSK_API_PAYMENT_CANCEL_SUPPORT_ERROR: 'Kiosk API payment does not support cancel.',
  KIOSK_API_PAYMENT_CANCEL_ERROR: 'Failed to cancel payment on terminal.',
  EXPO_PRINT_AUTH_ERROR: 'Failed to authenticate with Expo print.',
  KDS_CONNECTION_ERROR: 'Failed to connect to the KDS.',
  KDS_SEND_ERROR: 'Failed to send to the KDS.',
  INVALID_POS_API_TOKEN: 'Invalid POS API token provided. Please review provided credentials.',
  MENU_POS_NOT_FOUND: 'The POS failed to return a menu',
  INVALID_POS_URL: 'Invalid POS URL provided. Please review provided credentials.',
  CompCardAlreadyApplied: 'You can only apply a single comp card to this order',
  LocationDoesNotSupportEbtCashBenefit: 'This location does not accept EBT Cash Benefits',
  LocationDoesNotSupportEbtFoodStamps: 'This location does not accept EBT Food Stamps',
  EbtFoodStampNotAllowedOnPartiallyPaidOrder:
    'EBT Food Stamps cannot be used on an order that has already been partially paid.',
  RewardItemMissing: 'This reward cannot be applied to any items in your order.',
  LoyaltySignInAttemptsExceeded: 'You have exceeded the maximum number of sign-in attempts.',
};
